import UserAccountControl from './UserAccountControl';

export default UserAccountControl;
